export default __webpack_public_path__ + "static/media/Family.57cc5e4d.png";